import * as $bool from "../gleam_stdlib/gleam/bool.mjs";
import * as $int from "../gleam_stdlib/gleam/int.mjs";
import * as $list from "../gleam_stdlib/gleam/list.mjs";
import * as $p5js_gleam from "../p5js_gleam/p5js_gleam.mjs";
import * as $p5 from "../p5js_gleam/p5js_gleam/bindings.mjs";
import * as $behavior_tree from "./behavior_tree/behavior_tree.mjs";
import * as $bullet from "./bullet.mjs";
import * as $dungeon from "./dungeon.mjs";
import * as $enemy from "./enemy.mjs";
import {
  Ok,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "./gleam.mjs";
import * as $obstacle from "./obstacle.mjs";
import * as $player from "./player.mjs";
import * as $utils from "./utils.mjs";
import * as $vector from "./vector.mjs";

const FILEPATH = "src/bullet_heck_gleam.gleam";

class StartScreen extends $CustomType {}

/**
 * State of the world when the game is active.
 * 
 * @ignore
 */
class GameRunning extends $CustomType {
  constructor(dungeon, player, bullets, enemies, score) {
    super();
    this.dungeon = dungeon;
    this.player = player;
    this.bullets = bullets;
    this.enemies = enemies;
    this.score = score;
  }
}

/**
 * The game over screen when the player has lost.
 * 
 * @ignore
 */
class GameOver extends $CustomType {
  constructor(fell_in_pit, score) {
    super();
    this.fell_in_pit = fell_in_pit;
    this.score = score;
  }
}

function preload(p) {
  let minecraftia = $p5.load_font(p, "./fonts/Minecraftia-Regular.ttf");
  let worksans = $p5.load_font(p, "./fonts/WorkSans-Medium.ttf");
  let _pipe = $p5js_gleam.initialize_assets();
  let _pipe$1 = $p5js_gleam.insert_font(_pipe, "minecraftia", minecraftia);
  return $p5js_gleam.insert_font(_pipe$1, "worksans", worksans);
}

function setup(p) {
  let canvas_size = $dungeon.total_size();
  $p5.create_canvas(p, canvas_size, canvas_size);
  return new StartScreen();
}

function draw(p, state, assets) {
  let center_text = (txt) => {
    let canvas_size = $dungeon.total_size();
    return (canvas_size / 2.0) - ($p5.text_width(p, txt) / 2.0);
  };
  let h1 = 40;
  let h2 = 30;
  let h3 = 22;
  let h4 = 18;
  let par = 14;
  let $ = $p5js_gleam.get_font(assets, "minecraftia");
  let minecraftia;
  if ($ instanceof Ok) {
    minecraftia = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "bullet_heck_gleam",
      56,
      "draw",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 1385,
        end: 1456,
        pattern_start: 1396,
        pattern_end: 1411
      }
    )
  }
  let $1 = $p5js_gleam.get_font(assets, "worksans");
  let worksans;
  if ($1 instanceof Ok) {
    worksans = $1[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "bullet_heck_gleam",
      57,
      "draw",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $1,
        start: 1459,
        end: 1524,
        pattern_start: 1470,
        pattern_end: 1482
      }
    )
  }
  let canvas_size = $dungeon.total_size();
  $p5.background(p, "#000000");
  if (state instanceof StartScreen) {
    let title = "BULLET HECK";
    let start = "Press 'SPACE' to start";
    let ctrl = "Controls";
    let ctrl_move = "Use arrow keys or WASD to move";
    let ctrl_jump = "Press SPACE to jump";
    let ctrl_shoot = "Use mouse to aim, click to shoot";
    let _pipe = p;
    let _pipe$1 = $p5.fill(_pipe, "#0f0f0f");
    let _pipe$2 = $p5.rect(_pipe$1, 0.0, 0.0, canvas_size, canvas_size);
    let _pipe$3 = $p5.text_size(_pipe$2, h1);
    let _pipe$4 = $p5.fill(_pipe$3, "#ffffff");
    let _pipe$5 = $p5.text_font(_pipe$4, minecraftia);
    let _pipe$6 = $p5.text(
      _pipe$5,
      title,
      center_text(title),
      (canvas_size / 2.0) + 5.0,
    );
    let _pipe$7 = $p5.text_font(_pipe$6, worksans);
    let _pipe$8 = $p5.text_size(_pipe$7, h4);
    let _pipe$9 = $p5.text(
      _pipe$8,
      start,
      center_text(start),
      (canvas_size / 2.0) + 20.0,
    );
    let _pipe$10 = $p5.fill(_pipe$9, "#969696");
    let _pipe$11 = $p5.text(
      _pipe$10,
      ctrl,
      center_text(ctrl),
      (canvas_size / 2.0) + 200.0,
    );
    let _pipe$12 = $p5.text_size(_pipe$11, par);
    let _pipe$13 = $p5.text(
      _pipe$12,
      ctrl_move,
      center_text(ctrl_move),
      (canvas_size / 2.0) + 225.0,
    );
    let _pipe$14 = $p5.text(
      _pipe$13,
      ctrl_jump,
      center_text(ctrl_jump),
      (canvas_size / 2.0) + 245.0,
    );
    return $p5.text(
      _pipe$14,
      ctrl_shoot,
      center_text(ctrl_shoot),
      (canvas_size / 2.0) + 265.0,
    );
  } else if (state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    $dungeon.draw(p, dungeon);
    $list.each(enemies, (_capture) => { return $enemy.draw(p, _capture); });
    $list.each(bullets, (_capture) => { return $bullet.draw(p, _capture); });
    $player.draw(p, player);
    let hp_x = 22.0;
    let score_x = canvas_size - 100.0;
    let _pipe = p;
    let _pipe$1 = $p5.no_stroke(_pipe);
    let _pipe$2 = $p5.fill(_pipe$1, "#660000");
    let _pipe$3 = $p5.rect(_pipe$2, 0.0, 0.0, canvas_size, 36.0);
    let _pipe$4 = $p5.fill(_pipe$3, "#28e200");
    let _pipe$5 = $p5.rect(
      _pipe$4,
      hp_x + 15.0,
      12.0,
      $int.to_float(player.current_health),
      10.0,
    );
    let _pipe$6 = $p5.fill(_pipe$5, "#ffffff");
    let _pipe$7 = $p5.text_size(_pipe$6, par);
    let _pipe$8 = $p5.text(_pipe$7, "HP:", 10.0, hp_x);
    let _pipe$9 = $p5.text(_pipe$8, "Score:", score_x, 22.0);
    return $p5.text(_pipe$9, $int.to_string(score), score_x + 45.0, 22.0);
  } else {
    let fell_in_pit = state.fell_in_pit;
    let score = state.score;
    let canvas_size$1 = $dungeon.total_size();
    let game_over = "GAME OVER";
    let final_score = "Final Score: ";
    let restart = "Press 'R' to play again";
    let score_text = final_score + $int.to_string(score);
    let _block;
    if (fell_in_pit) {
      _block = "You fell to your death.";
    } else {
      _block = "Turns out, red things hurt.";
    }
    let cause_of_death = _block;
    let _pipe = p;
    let _pipe$1 = $p5.fill(_pipe, "#0f0f0f");
    let _pipe$2 = $p5.rect(_pipe$1, 0.0, 0.0, canvas_size$1, canvas_size$1);
    let _pipe$3 = $p5.fill(_pipe$2, "#e20000");
    let _pipe$4 = $p5.text_size(_pipe$3, h2);
    let _pipe$5 = $p5.text_font(_pipe$4, minecraftia);
    let _pipe$6 = $p5.text(
      _pipe$5,
      game_over,
      center_text(game_over),
      (canvas_size$1 / 2.0) - 25.0,
    );
    let _pipe$7 = $p5.text_size(_pipe$6, h3);
    let _pipe$8 = $p5.text_font(_pipe$7, worksans);
    let _pipe$9 = $p5.text(
      _pipe$8,
      cause_of_death,
      center_text(cause_of_death),
      (canvas_size$1 / 2.0) - 15.0,
    );
    let _pipe$10 = $p5.fill(_pipe$9, "#ffffff");
    let _pipe$11 = $p5.text(
      _pipe$10,
      score_text,
      center_text(score_text),
      (canvas_size$1 / 2.0) + 45.0,
    );
    let _pipe$12 = $p5.text_size(_pipe$11, h4);
    return $p5.text(
      _pipe$12,
      restart,
      center_text(restart),
      (canvas_size$1 / 2.0) + 70.0,
    );
  }
}

function spawn_enemies(dungeon) {
  let enemies_to_spawn = 4;
  return $list.map(
    $list.range(0, enemies_to_spawn - 1),
    (_) => {
      let position = $dungeon.get_location_to_place_object(
        dungeon.rooms,
        dungeon.pits,
      );
      return $enemy.new_enemy(position);
    },
  );
}

function on_key_pressed(key, _, state) {
  if (key === "r") {
    return new StartScreen();
  } else if (key === " ") {
    if (state instanceof StartScreen) {
      let canvas_size = $dungeon.total_size();
      let dungeon = $dungeon.generate_dungeon();
      return new GameRunning(
        dungeon,
        $player.new_player(
          new $vector.Vector(canvas_size / 2.0, canvas_size / 2.0, 0.0),
        ),
        toList([]),
        spawn_enemies(dungeon),
        0,
      );
    } else if (state instanceof GameRunning) {
      let dungeon = state.dungeon;
      let player = state.player;
      let bullets = state.bullets;
      let enemies = state.enemies;
      let score = state.score;
      return new GameRunning(
        dungeon,
        $player.jump(player),
        bullets,
        enemies,
        score,
      );
    } else {
      return state;
    }
  } else if (key === "w" && state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    return new GameRunning(
      dungeon,
      $player.accelerate_y(player, false),
      bullets,
      enemies,
      score,
    );
  } else if (key === "s" && state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    return new GameRunning(
      dungeon,
      $player.accelerate_y(player, true),
      bullets,
      enemies,
      score,
    );
  } else if (key === "a" && state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    return new GameRunning(
      dungeon,
      $player.accelerate_x(player, false),
      bullets,
      enemies,
      score,
    );
  } else if (key === "d" && state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    return new GameRunning(
      dungeon,
      $player.accelerate_x(player, true),
      bullets,
      enemies,
      score,
    );
  } else {
    return state;
  }
}

function on_key_released(key, _, state) {
  if (state instanceof GameRunning) {
    if (key === "w") {
      let dungeon = state.dungeon;
      let player = state.player;
      let bullets = state.bullets;
      let enemies = state.enemies;
      let score = state.score;
      return new GameRunning(
        dungeon,
        $player.stop_y(player),
        bullets,
        enemies,
        score,
      );
    } else if (key === "s") {
      let dungeon = state.dungeon;
      let player = state.player;
      let bullets = state.bullets;
      let enemies = state.enemies;
      let score = state.score;
      return new GameRunning(
        dungeon,
        $player.stop_y(player),
        bullets,
        enemies,
        score,
      );
    } else if (key === "a") {
      let dungeon = state.dungeon;
      let player = state.player;
      let bullets = state.bullets;
      let enemies = state.enemies;
      let score = state.score;
      return new GameRunning(
        dungeon,
        $player.stop_x(player),
        bullets,
        enemies,
        score,
      );
    } else if (key === "d") {
      let dungeon = state.dungeon;
      let player = state.player;
      let bullets = state.bullets;
      let enemies = state.enemies;
      let score = state.score;
      return new GameRunning(
        dungeon,
        $player.stop_x(player),
        bullets,
        enemies,
        score,
      );
    } else {
      return state;
    }
  } else {
    return state;
  }
}

function on_mouse_clicked(x, y, state) {
  if (state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    return $bool.guard(
      !$player.can_player_fire(player),
      state,
      () => {
        let firing_direction = $vector.vector_2d(
          $vector.subtract(new $vector.Vector(x, y, 0.0), player.position),
        );
        let p;
        p = player.position;
        return new GameRunning(
          dungeon,
          new $player.Player(
            player.position,
            player.velocity,
            player.acceleration,
            $utils.now_in_milliseconds(),
            player.last_hit_time,
            player.current_health,
            player.max_health,
          ),
          listPrepend(
            $bullet.spawn_bullet(
              new $vector.Vector(p.x, p.y, 0.0),
              firing_direction,
              true,
            ),
            bullets,
          ),
          enemies,
          score,
        );
      },
    );
  } else {
    return state;
  }
}

function on_tick(state) {
  if (state instanceof GameRunning) {
    let dungeon = state.dungeon;
    let player = state.player;
    let bullets = state.bullets;
    let enemies = state.enemies;
    let score = state.score;
    let old_position = player.position;
    let moved = $player.move(player);
    let _block;
    let $ = $dungeon.can_move(dungeon, old_position, moved.position);
    if ($) {
      _block = moved;
    } else {
      _block = new $player.Player(
        new $vector.Vector(
          old_position.x,
          old_position.y,
          old_position.z + player.velocity.z,
        ),
        player.velocity,
        player.acceleration,
        player.last_fire_time,
        player.last_hit_time,
        player.current_health,
        player.max_health,
      );
    }
    let player$1 = _block;
    return $bool.guard(
      (player$1.position.z <= 0.0) && $dungeon.is_over_pit(
        dungeon,
        player$1.position,
      ),
      new GameOver(true, score),
      () => {
        let player$2 = $player.update_velocity(player$1);
        let player$3 = $player.apply_gravity(player$2);
        let player$4 = $list.fold(
          dungeon.obstacles,
          player$3,
          (player, o) => {
            let $1 = $obstacle.collides_with(
              o,
              player.position,
              $player.player_size,
            ) && !$player.is_player_invulnerable(player);
            if ($1) {
              return $player.apply_damage(player, $obstacle.damage);
            } else {
              return player;
            }
          },
        );
        let $1 = $list.fold(
          enemies,
          [toList([]), bullets, player$4, score],
          (acc, e) => {
            let enemies$1;
            let bullets$1;
            let player$5;
            let score$1;
            enemies$1 = acc[0];
            bullets$1 = acc[1];
            player$5 = acc[2];
            score$1 = acc[3];
            let $2 = e.btree(
              new $behavior_tree.BehaviorInput(
                e,
                new $enemy.Inputs(enemies$1, dungeon, player$5),
              ),
            );
            let enemy;
            let new_bullets;
            enemy = $2.entity;
            new_bullets = $2.additional_outputs.bullets;
            let enemy$1 = $enemy.apply_gravity(enemy);
            let bullets$2 = $list.append(new_bullets, bullets$1);
            return $bool.guard(
              (enemy$1.position.z <= 0.0) && $dungeon.is_over_pit(
                dungeon,
                enemy$1.position,
              ),
              [enemies$1, bullets$2, player$5, score$1 + $enemy.value],
              () => {
                let _block$1;
                let $3 = $enemy.collides_with(
                  enemy$1,
                  player$5.position,
                  $player.player_size,
                ) && !$player.is_player_invulnerable(player$5);
                if ($3) {
                  _block$1 = $player.apply_damage(player$5, $enemy.damage);
                } else {
                  _block$1 = player$5;
                }
                let player$6 = _block$1;
                let enemy$2 = $list.fold(
                  dungeon.obstacles,
                  enemy$1,
                  (enemy, o) => {
                    let $4 = $obstacle.collides_with(
                      o,
                      enemy.position,
                      $enemy.enemy_size,
                    );
                    if ($4) {
                      return $enemy.apply_damage(enemy, $obstacle.damage);
                    } else {
                      return enemy;
                    }
                  },
                );
                return $bool.guard(
                  $enemy.is_enemy_dead(enemy$2),
                  [enemies$1, bullets$2, player$6, score$1 + $enemy.value],
                  () => {
                    return [
                      listPrepend(enemy$2, enemies$1),
                      bullets$2,
                      player$6,
                      score$1,
                    ];
                  },
                );
              },
            );
          },
        );
        let enemies$1;
        let bullets$1;
        let player$5;
        let score$1;
        enemies$1 = $1[0];
        bullets$1 = $1[1];
        player$5 = $1[2];
        score$1 = $1[3];
        let _block$1;
        let _pipe = bullets$1;
        _block$1 = $list.filter(_pipe, $bullet.is_still_alive);
        let bullets$2 = _block$1;
        let $2 = $list.fold(
          bullets$2,
          [toList([]), player$5, enemies$1, score$1],
          (acc, b) => {
            return $bool.guard(
              !$dungeon.can_move(
                dungeon,
                b.position,
                $bullet.advance_bullet(b).position,
              ),
              acc,
              () => {
                let bullets$3;
                let player$6;
                let enemies$2;
                let score$2;
                bullets$3 = acc[0];
                player$6 = acc[1];
                enemies$2 = acc[2];
                score$2 = acc[3];
                return $bool.guard(
                  (!b.belongs_to_player && $bullet.collides_with(
                    b,
                    player$6.position,
                    $player.player_size,
                  )) && !$player.is_player_invulnerable(player$6),
                  [
                    bullets$3,
                    $player.apply_damage(player$6, $bullet.enemy_damage),
                    enemies$2,
                    score$2,
                  ],
                  () => {
                    let $3 = $list.fold(
                      enemies$2,
                      [toList([]), score$2, false],
                      (acc, e) => {
                        let enemies$3;
                        let score$3;
                        let any_hit;
                        enemies$3 = acc[0];
                        score$3 = acc[1];
                        any_hit = acc[2];
                        let _block$2;
                        let $5 = b.belongs_to_player && $bullet.collides_with(
                          b,
                          e.position,
                          $enemy.enemy_size,
                        );
                        if ($5) {
                          _block$2 = [
                            $enemy.apply_damage(e, $bullet.player_damage),
                            true,
                          ];
                        } else {
                          _block$2 = [e, any_hit];
                        }
                        let $4 = _block$2;
                        let e$1;
                        let any_hit$1;
                        e$1 = $4[0];
                        any_hit$1 = $4[1];
                        return $bool.guard(
                          $enemy.is_enemy_dead(e$1),
                          [enemies$3, score$3 + $enemy.value, any_hit$1],
                          () => {
                            return [
                              listPrepend(e$1, enemies$3),
                              score$3,
                              any_hit$1,
                            ];
                          },
                        );
                      },
                    );
                    let enemies$3;
                    let score$3;
                    let any_hit;
                    enemies$3 = $3[0];
                    score$3 = $3[1];
                    any_hit = $3[2];
                    if (any_hit) {
                      return [bullets$3, player$6, enemies$3, score$3];
                    } else {
                      return [
                        listPrepend($bullet.advance_bullet(b), bullets$3),
                        player$6,
                        enemies$3,
                        score$3,
                      ];
                    }
                  },
                );
              },
            );
          },
        );
        let bullets$3;
        let player$6;
        let enemies$2;
        let score$2;
        bullets$3 = $2[0];
        player$6 = $2[1];
        enemies$2 = $2[2];
        score$2 = $2[3];
        return $bool.guard(
          $player.is_player_dead(player$6),
          new GameOver(false, score$2),
          () => {
            if (enemies$2 instanceof $Empty) {
              let canvas_size = $dungeon.total_size();
              let dungeon$1 = $dungeon.generate_dungeon();
              return new GameRunning(
                dungeon$1,
                $player.new_player(
                  new $vector.Vector(canvas_size / 2.0, canvas_size / 2.0, 0.0),
                ),
                toList([]),
                spawn_enemies(dungeon$1),
                score$2,
              );
            } else {
              return new GameRunning(
                dungeon,
                player$6,
                bullets$3,
                enemies$2,
                score$2,
              );
            }
          },
        );
      },
    );
  } else {
    return state;
  }
}

export function main() {
  let _pipe = $p5js_gleam.create_sketch_with_preloading(preload, setup, draw);
  let _pipe$1 = $p5js_gleam.set_on_key_pressed(_pipe, on_key_pressed);
  let _pipe$2 = $p5js_gleam.set_on_key_released(_pipe$1, on_key_released);
  let _pipe$3 = $p5js_gleam.set_on_mouse_clicked(_pipe$2, on_mouse_clicked);
  let _pipe$4 = $p5js_gleam.set_on_tick(_pipe$3, on_tick);
  return $p5.start_sketch(_pipe$4);
}
